import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful';
import type { TypeStackedCardItemSkeleton } from './TypeStackedCardItem';

export interface TypeBlockStackedCardsFields {
    internalName: EntryFieldTypes.Symbol;
    overline?: EntryFieldTypes.Symbol;
    headerText?: EntryFieldTypes.Text;
    paragraph?: EntryFieldTypes.Text;
    cards: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeStackedCardItemSkeleton>>;
}

export type TypeBlockStackedCardsSkeleton = EntrySkeletonType<TypeBlockStackedCardsFields, 'blockStackedCards'>;
export type TypeBlockStackedCards<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
    TypeBlockStackedCardsSkeleton,
    Modifiers,
    Locales
>;

export function isTypeBlockStackedCards<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
    entry: Entry<EntrySkeletonType, Modifiers, Locales>
): entry is TypeBlockStackedCards<Modifiers, Locales> {
    return entry.sys.contentType.sys.id === 'blockStackedCards';
}
